import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/api/queryKeys";
import { cachePolicies } from "@/lib/api/cache-policies";
import { listByokKeys } from "../api";

export function useByokKeys() {
  return useQuery({
    queryKey: queryKeys.byok.list(),
    queryFn: listByokKeys,
    staleTime: cachePolicies.byok.list.staleTime,
    gcTime: cachePolicies.byok.list.gcTime,
  });
}
